import {FetcherSettings, MAX_RETRIES_REQUESTS_NUMBER} from '@chekin/api';

const DefaultResolverSettings: FetcherSettings = {
  errorRetryLimit: MAX_RETRIES_REQUESTS_NUMBER,
};

export function fetcher<F extends (...args: Parameters<F>) => ReturnType<F>>(
  fetcher: F,
  ...params: Parameters<F>
) {
  return fetcher.apply(fetcher, [...params, DefaultResolverSettings] as Parameters<F>);
}
